import React from "react"
import clsx from "clsx"
import {
	Grid
} from "@material-ui/core"

import { Divider, AccessibleDrawer, Profile } from "@/components"

import useChatStyles from "@/pages/Attendance/Chat/styles"
import useSidebarDrawerStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/styles"
import { isSmallScreen } from "@/utils/checkDevice"
import useStyles from "@/pages/Attendance/Chat/ChatListPanel/ChatListHeader/ProfileInfo/styles"
import useDidMount from "@/hooks/useDidMount"

import HeaderDrawer from "@/pages/Attendance/Chat/HeaderDrawer"

type ProfileInfoProps = {
	openDrawer: boolean
	onClose: () => void
	isCollapsed: boolean
}

const ProfileInfo = (props: ProfileInfoProps) => {
	const { openDrawer, onClose, isCollapsed } = props

	const classes = useStyles()
	const chatClasses = useChatStyles()
	const sidebarDrawerClasses = useSidebarDrawerStyles({ isCollapsed })

	const handleCloseDrawer = () => {
		onClose()
	}

	const eventKeyDownHandler = (event: KeyboardEvent) => {
		const { key } = event

		if (key === "Escape") {
			handleCloseDrawer()
		}
	}

	useDidMount(() => {
		window.addEventListener(
			"keydown",
			eventKeyDownHandler,
			{ capture: true }
		)
	})

	return (
		<AccessibleDrawer
			id="new-chat-drawer"
			anchor="left"
			open={openDrawer}
			variant="persistent"
			onClose={handleCloseDrawer}
			onMobileBackButtonPress={handleCloseDrawer}
			classes={{
				paper: clsx(chatClasses.drawerPaper, !isSmallScreen && sidebarDrawerClasses.drawerPaperOffset)
			}}
		>
			<Grid className={classes.gridContainer} container>
				<Grid item xs={12}>
					<HeaderDrawer
						title="Meus dados"
						onClose={handleCloseDrawer}
					/>
				</Grid>

				<Divider size={2} orientation="horizontal" />

				<Grid className={classes.gridItemProfile} item xs={12}>
					<Profile />
				</Grid>
			</Grid>
		</AccessibleDrawer>
	)
}

export default ProfileInfo
